@if (showSummary) {
  <div class="mb-3" [ngClass]="{'term-benefit': isTermWizard }">
    @if (isTermWizard) {
      <div class="message-card red mb-3">
        <mwp-text-translate text="Terminating Benefits" jsonKey="terminatingBenefitsTermWizard" />
      </div>
    }
    <div class="content-container table-comp">
      <div class="title">
        <mwp-text-translate text="Benefit Requests" jsonKey="benefitRequests" />
      </div>
      <div class="content p-0">
        <mwp-card-benefit-summary [benefitSummaryList]="summaryList" [isNoBorder]="true" [displayBenefitColumn]="true" [enableToggle]="true" [showSummary]="false" colSpanWidth="6%" [isEnrollmentSummary]="true" />
      </div>
      @if (showSummaryTotal) {
        <div class="title">
          <mwp-text-translate [text]="summaryHeader" [jsonKey]="summaryHeader" />
        </div>
        <div class="content p-0">
          <mwp-card-benefit-summary [benefitSummaryList]="summaryList" [isNoBorder]="true" [displayBenefitColumn]="true" [displayProcessColumn]="true" [enableToggle]="true" [showSummaryGridOnly]="true" [isEnrollmentSummary]="true" />
        </div>
        }
      <div class="footer">
        <mwp-benefit-enrollment-wizard-control (emitComplete)="submitSummary()"></mwp-benefit-enrollment-wizard-control>      
      </div>
    </div>
  </div>
}
